import './App.scss';

import React from 'react';
import { NotificationContainer } from 'react-notifications';

import Chat from './containers/Chat';
import firebase from './services/firebase';

firebase.analytics();

const App: React.FC = () => (
  <>
    <Chat />
    <NotificationContainer />
  </>
);

export default App;
